var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.733,
    height: 17.73,
    viewBox: "0 0 17.733 17.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7550",
    "data-name": "Path 7550",
    d: "M-1373.1-2851.134h-5.262a1.9,1.9,0,0,1-2.01-2.008q0-5.272,0-10.543a1.9,1.9,0,0,1,2.009-2.009q4.155,0,8.309,0a.484.484,0,0,0,.377-.159q1.175-1.189,2.362-2.366a1.9,1.9,0,0,1,2.855,0q.6.591,1.189,1.189a1.9,1.9,0,0,1,0,2.828q-1.194,1.2-2.394,2.39a.46.46,0,0,0-.146.362q.006,4.184,0,8.367a1.883,1.883,0,0,1-1.421,1.884,2.394,2.394,0,0,1-.586.064Q-1370.46-2851.13-1373.1-2851.134Zm6.023-9.251c-.082.077-.134.124-.183.172q-2.357,2.356-4.719,4.708a1.21,1.21,0,0,1-.517.3c-1.464.388-2.932.759-4.4,1.133a.886.886,0,0,1-.312.033.638.638,0,0,1-.512-.9c.47-1.37.939-2.74,1.421-4.106a1.316,1.316,0,0,1,.3-.476q2.348-2.366,4.71-4.717c.049-.049.1-.1.174-.185h-7.251a.647.647,0,0,0-.736.741q0,5.272,0,10.542a.651.651,0,0,0,.738.741h10.544c.51,0,.745-.238.745-.754q0-3.5,0-7Zm-.592-5.583-7.082,7.079,2.135,2.137,7.082-7.08Zm-7.771,8.323-.711,2.065,2.208-.565Z",
    transform: "translate(1380.374 2868.864)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconWhite);
export default __webpack_public_path__ + "static/media/edit-icon-white.5ac2a28cf95fe1234867c4b852d62c6f.svg";
export { ForwardRef as ReactComponent };